import { createLucideIcon } from "lucide-react";

export const SecurityCheck = createLucideIcon(
    "SecurityCheck",
    [
        [
            "path",
            {
                d: "M11.9982 2C8.99043 2 7.04018 4.01899 4.73371 4.7549C3.79589 5.05413 3.32697 5.20374 3.1372 5.41465C2.94743 5.62556 2.89186 5.93375 2.78072 6.55013C1.59143 13.146 4.1909 19.244 10.3903 21.6175C11.0564 21.8725 11.3894 22 12.0015 22C12.6135 22 12.9466 21.8725 13.6126 21.6175C19.8116 19.2439 22.4086 13.146 21.219 6.55013C21.1078 5.93364 21.0522 5.6254 20.8624 5.41449C20.6726 5.20358 20.2037 5.05405 19.2659 4.75499C16.9585 4.01915 15.0061 2 11.9982 2Z",
                key: "wjm6le",
            },
        ],
        [
            "path",
            {
                d: "M9 13C9 13 10 13 11 15C11 15 14.1765 10 17 9",
                key: "1xski9",
            },
        ],
    ],
);
